var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"max":"9999-12-31","label":_vm.label,"type":"date","required":_vm.required,"rules":_vm.rules},on:{"input":_vm.onInput},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }